<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  import IwanButton from '@/comps-sdk/components/button';
  import IwanDrawer from '@/comps-sdk/components/drawer/index';

  const dispatch = createEventDispatcher();

  let drawerShow = true;
  let account = '';

  let btnDisabled: boolean;
  $: {
    const qqLength = account.length;
    btnDisabled = qqLength === 0 || qqLength > 11 || !/^[0-9]*$/.test(account);
  }

  const handleCloseDrawer = () => {
    drawerShow = false;
    dispatch('close');
  };

  const handleConfirm = () => {
    dispatch('confirm', {
      qq: account,
    });
    drawerShow = false;
  };
</script>

<IwanDrawer bind:value={drawerShow} on:input={handleCloseDrawer}>
  <div class="qb-input-panel">
    <div class="input-title">填写领取的QQ帐号</div>
    <div class={`input-wrapper ${btnDisabled ? 'error-input' : ''}`}>
      <input bind:value={account} type="text" placeholder="请输入QQ账号" />
      {#if btnDisabled && account.length !== 0}
        <div class="error-hint">请输入合法的QQ账号</div>
      {/if}
    </div>
    <IwanButton class="qb-button-wrapper" disabled={btnDisabled} on:click={handleConfirm}>确定</IwanButton>
  </div>
</IwanDrawer>

<style lang="scss">
  .qb-input-panel {
    .input-title {
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 18px;
      color: #191919;
      letter-spacing: 0;
      text-align: center;
      margin-top: 40px;
    }

    .input-wrapper {
      margin: 80px 0;
      text-align: center;

      > input {
        border: none;
        outline: none;
        width: 255px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
        height: 28px;
        text-align: center;

        &::placeholder {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 16px;
          color: rgba(25, 25, 25, 0.5);
          letter-spacing: 0;
          text-align: center;
        }
      }

      .error-hint {
        font-size: 10px;
        color: red;
        margin-top: 4px;
      }
    }

    :global(.qb-button-wrapper) {
      margin: 20px 0;
      text-align: center;
    }
  }
</style>
